import Model from '@/models/Model';

export default class Roles extends Model {
    get route () {
        return 'roles';
    }

    static get className () {
        return 'Role';
    }

    static get isInStore () {
        return true;
    }
}
